<template>
  <div class="login-page">
    <div class="container-370">
      <div class="verticle-middle w-370">
        <div class="logo-choose-role text-center">
          <img class="w-180" src="../../assets/images/parts-logo.png" alt="">
        </div>
        <div class="button-group mt-47">
          ポケットファーマシーから開きました。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    console.log(`name: ${this.$route.name}, token: ${this.$route.query.token}`)
    let token = this.$route.query.token
    this.$auth.logout()
    setTimeout(() => {
      return this.$router.push({
        name: 'ppLogin',
        params: {token}
      })
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/PpLoginPre.vue